import * as types from '../../mutation-types'
// import {NoAccessLoader, NotFoundLoader} from '../../../'
import NoAccess from '../../../components/NoAccess'
import NotFound from '../../../components/NotFound'
import Empty from '../../../components/Empty'
import {generateFlatRoutesFromMenu} from '../../../util/helpers'
import routerBuilder from '../../../router'

export const NoAccessRouteName = 'NoAccess'
export const NotFoundRouteName = 'NotFound'
export const EmptyRoutePath = '/_' // Empty route path "/_" should only ever be used for reload component hack in this script!

const globalMenuItems = [
  // Menu/route items used by all apps
  {
    name: NoAccessRouteName,
    path: '/no-access',
    component: NoAccess,
    show: false,
    meta: {
      exact: true,
      icon: '',
    }
  },
  {
    name: 'Empty',
    path: EmptyRoutePath, // empty
    component: Empty,
    show: false,
    meta: {
      exact: true,
      icon: ''
    }
  },
  {
    name: NotFoundRouteName,
    path: '*',
    component: NotFound,
    show: false,
    meta: {
      exact: false,
      icon: ''
    }
  }
]

export default function (config) {
  const menuParts = config.menuParts
  const state = {
    items: [
      ...globalMenuItems
    ],
    navItems: [],
    navItemUpdaters: [],
    navItemMap: {},
    init: false,
    updated: false
  }

  function subChildNavItems (state) {
    return childNavItems(state).reduce((acc, n) => {
      acc.push(...n.items)
      return acc
    }, [])
  }

  function childNavItems (state) {
    return state.navItems.reduce((acc, n) => {
      acc.push(...n.items)
      return acc
    }, [])
  }

  function navItemUpdaters (state) {
    // Create array of  nav item updater methods, with children methods first, so parent updaters are aware of changes to children when they execute
    return subChildNavItems(state).map(n => n.updater).concat(childNavItems(state).map(n => n.updater)).concat(state.navItems.map(n => n.updater))
  }

  function buildNavItemMap (vueContext, state, navItems) {
    if (!navItems) return
    navItems.forEach((n) => {
      vueContext.$set(state.navItemMap, n.to, n)
      buildNavItemMap(vueContext, state, n.items)
    })
  }

  /**
   * Convert server-side menu entry to JS menu item
   */
  function ssMenuToMenuItem (vueContext, state, ssMenu) {
    var componentLoader = menuParts.components[ssMenu.component]
    if (ssMenu.component && !componentLoader) {
      console.error('Unable to find component "' + ssMenu.component + '" in ' + ssMenu.name, ssMenu, menuParts)
      componentLoader = NotFound
    }
    const propGen = menuParts.propGens[ssMenu.propGen]
    if (ssMenu.propGen && !propGen) {
      console.error('Unable to find propGen "' + ssMenu.propGen + '" in ' + ssMenu.name, ssMenu, menuParts)
    }
    const contextGen = menuParts.contextMenuGen[ssMenu.contextGen]
    if (ssMenu.contextGen && !contextGen) {
      console.error('Unable to find contextGen "' + ssMenu.contextGen + '" in ' + ssMenu.name, ssMenu, menuParts)
    }
    const noticeGen = menuParts.noticeGens[ssMenu.noticeGen]
    if (ssMenu.noticeGen && !noticeGen) {
      console.error('Unable to find noticeGen "' + ssMenu.noticeGen + '" in ' + ssMenu.name, ssMenu, menuParts)
    }
    const access = ssMenu.access
    const accessMethod = access && access.method && menuParts.accessMethods[access.method]
    if (access && access.method && !accessMethod) {
      console.error('Unable to find accessMethod "' + access.method + '" in ' + ssMenu.name, ssMenu, menuParts)
    }
    const _checkAccess = (vue) => {
      if (!access) return true // no access validation
      const fta = vue.$ftAccess
      const ftCs = vue.$ftCS
      let allow = true
      allow = allow && access.any && access.any.length ? access.any.find(a => fta[a]) : allow
      allow = allow && access.all && access.all.length ? !access.all.find(a => !fta[a]) : allow
      allow = allow && access.none && access.none.length ? !access.none.find(a => fta[a]) : allow
      allow = allow && accessMethod ? accessMethod(vue) : allow
      allow = allow && access.sAny && access.sAny.length ? access.sAny.find(a => ftCs[a]) : allow
      allow = allow && access.sAll && access.sAll.length ? !access.sAll.find(a => !ftCs[a]) : allow
      allow = allow && access.sNone && access.sNone.length ? !access.sNone.find(a => ftCs[a]) : allow
      return allow
    }
    const menuItem = {
      name: ssMenu.name,
      path: ssMenu.path,
      component: componentLoader,
      props: propGen,
      redirect: ssMenu.redirect,
      show: ssMenu.show,
      meta: {
        icon: ssMenu.icon,
        label: ssMenu.label || ssMenu.name,
        showBg: ssMenu.showBg,
        description: ssMenu.description,
        access: _checkAccess,
        contextMenu: contextGen,
        notice: noticeGen
      },
      children: ssMenu.children && ssMenu.children.length ? ssMenu.children.map(c => ssMenuToMenuItem(vueContext, state, c)) : null
    }
    return menuItem
  }

  function buildMenuArray (vueContext, state) {
    state.items =  vueContext.$set(state, 'items', (vueContext.$ftAC && vueContext.$ftAC.menu || []).map(c => ssMenuToMenuItem(vueContext, state, c)).concat(globalMenuItems))
  }

  function menuArrayToNavItems (menu, vueContext, parentPath, parent) {
    const currentPath = vueContext.$route.path
    if (!menu) return []
    parentPath = parentPath || ''
    const navItems = menu.map(m => {
      const meta = m.meta || {}
      const notice = typeof meta.notice === 'function' ? meta.notice : () => {return []}
      const access = typeof meta.access === 'function' ? meta.access : () => true
      if (m.path && m.path.match(/^\//)) parentPath = ''
      const path = m.path ? (parentPath.match(/\/$/) || m.path.match(/^\//) ? parentPath : parentPath + '/') + m.path : ''
      const childPathPrefix = path.match(/\/$/) ? path : path + '/'
      const navItem = {
        title: meta.label || m.name,
        to: meta.to || (path ? path : ''),
        icon: meta.icon,
        href: meta.href,
        exact: meta.exact,
        access: () => access(vueContext),
        getNotice: () => notice(vueContext),
        meta: meta,
        linkAction: meta.linkAction,
        description: meta && meta.description,
        menuItem: m
      }
      vueContext.$set(navItem, 'items', menuArrayToNavItems(m.children, vueContext, childPathPrefix, navItem)) // Make reactive
      vueContext.$set(navItem, 'show', m.show && access(vueContext)) // Make reactive
      // TODO: make non-exact match a regexp to take into account path separators
      vueContext.$set(navItem, 'active', navItem.to && (navItem.exact ? navItem.to === currentPath : currentPath.indexOf(navItem.to) === 0)) // Make reactive
      vueContext.$set(navItem, 'activePath', navItem.to && navItem.to === currentPath) // Make reactive
      vueContext.$set(navItem, 'activeChildPath', !!navItem.items.find(n => n.activePath || !!(n.items && n.items.find(nn => nn.activePath)))) // Make reactive
      // vueContext.$set(navItem, 'activeChild', vueContext.findActiveNavItemAndDepth(navItem, currentPath)) // Make reactive
      vueContext.$set(navItem, 'notice', notice(vueContext).slice(0, 1)) // Make reactive
      vueContext.$set(navItem, 'hasSub', !!navItem.items.find(n => n.show)) // Make reactive
      navItem.updater = (updatedPath) => {
        const show = m.show && access(vueContext)
        if (show !== navItem.show) vueContext.$set(navItem, 'show', show) // Keep reactive
        const hasSub = !!navItem.items.find(n => n.show)
        if (hasSub !== navItem.hasSub) vueContext.$set(navItem, 'hasSub', hasSub) // Keep reactive
        const active = navItem.to && (m.exact ? navItem.to === updatedPath : updatedPath.indexOf(navItem.to) === 0)
        if (active !== navItem.active) vueContext.$set(navItem, 'active', active) // Keep reactive
        const activePath = navItem.to && navItem.to === updatedPath
        if (activePath !== navItem.activePath) vueContext.$set(navItem, 'activePath', activePath) // Keep reactive
        const activeChildPath = !!navItem.items.find(n => n.activePath || !!(n.items && n.items.find(nn => nn.activePath)))
        if (activeChildPath !== navItem.activeChildPath) vueContext.$set(navItem, 'activeChildPath', activeChildPath) // Keep reactive
        const notices = notice(vueContext).slice(0, 1)
        const currentNotices = navItem.notice
        if (currentNotices.length + notices.length && JSON.stringify(notices) !== JSON.stringify(navItem.notice)) {
          // Only update notices if they changed
          vueContext.$set(navItem, 'notice', notices) // Keep reactive
        }
        // console.warn('Updated navItem', navItem, updatedPath)
      }
      return navItem
    })
    return navItems
  }

  function buildMenu (state, vueContext) {
    vueContext.$set(state, 'updated', false) // Keep reactive
    buildMenuArray(vueContext, state)
    buildNavItems(state, vueContext)
    // vueContext.$set(state, 'navItems', menuArrayToNavItems(state.items, vueContext)) // Keep reactive
    // vueContext.$set(state, 'navItemUpdaters', navItemUpdaters(state)) // Keep reactive
    // Re-build routes
    const routes = generateFlatRoutesFromMenu(state.items)
    // Hack to clear old routes (will probably need to change when moving to vue3 / vue-router4)
    const newRouter = routerBuilder(config) // Create a new router
    const router = vueContext.$router
    router.matcher = newRouter.matcher // Replace our router's old matcher with the new matcher (this should clear all routes)
    // Add new routes
    router.addRoutes(routes)
    // Set our menus as initialized
    vueContext.$set(state, 'init', true) // Keep reactive
    // We've fully loaded menus from server side call if we have more menu items than the base items
    const updated = state.items.length > globalMenuItems.length
    if (updated) {
      const currentRoute = router.currentRoute
      const shouldBe = router.match(currentRoute.fullPath)
      // It's very possible we were on a "NotFound" component because our router wasn't updated or
      // our access has changed and we should no-longer have access to the current component.
      // Check the current route matcher to see if the current path routes to a different route than before.
      // If so, we'll do a hack to "reload" the current route by switching to the "Empty" component path
      // then, switching back to the current full path to load the proper component.
      if (shouldBe.name !== currentRoute.name && !currentRoute.query.sk && (currentRoute.name === NotFoundRouteName || shouldBe.name === NoAccessRouteName)) {
        // Hack to refresh current route
        router.replace(EmptyRoutePath)
        router.replace(currentRoute.fullPath)
      }
    }
    // Set our menus as fully loaded, if we got menus from API call
    vueContext.$set(state, 'updated', updated) // Keep reactive
  }

  function buildNavItems (state, vueContext) {
    vueContext.$set(state, 'navItems', menuArrayToNavItems(state.items, vueContext)) // Keep reactive
    vueContext.$set(state, 'navItemUpdaters', navItemUpdaters(state)) // Keep reactive
  }

  function updateNavItems (state, vueContext) {
    const updatedPath = vueContext.$route.path
    state.navItemUpdaters.forEach(u => u(updatedPath))
  }

  const mutations = {
    [types.BUILD_MENU] (state, vueContext) {
      buildMenu(state, vueContext)
    },
    [types.BUILD_NAV_ITEMS] (state, vueContext) {
      if (!state.init) {
        buildMenu(state, vueContext)
        // updateNavItems(state, vueContext)
      } else {
        // vueContext.$set(state, 'navItems', menuArrayToNavItems(state.items, vueContext)) // Keep reactive
        // vueContext.$set(state, 'navItemUpdaters', navItemUpdaters(state)) // Keep reactive
        buildNavItems(state, vueContext)
      }
      buildNavItemMap(vueContext, state, state.navItems)
    },
    [types.UPDATE_NAV_ITEMS] (state, vueContext) {
      updateNavItems(state, vueContext)
    }
  }

  return {
    state,
    mutations
  }
}
